@if (isHierarchyMode) {
<button pButton type="button" style="margin-bottom: 8px;" [label]="allExpanded ? 'Chiudi tutto' : 'Apri tutto'"
  title="{{allExpanded ? 'Chiudi tutto' : 'Apri tutto'}}" (click)="openOrCloseAll()"></button>
}
@if (data() && data().originalRequest) {
<p-treeTable [value]="data().results" [paginator]="paginator() && data().results?.length ?? 0 > 0" [filterDelay]="0" [lazy]="isLazy()"
  [selectionMode]="selectionMode" [(selection)]="selectedRow" (onNodeSelect)="onRowSelection($event)"
  (onNodeUnselect)="onRowSelection(null)" (onLazyLoad)="lazyLoad($event)" [totalRecords]="data().totalCount"
  (onHeaderCheckboxToggle)="onAllRowsSelection($event)"
  [sortField]="data().originalRequest.sortField" [sortOrder]="data().originalRequest.sortOrder"
  [columns]="activeColumnMetadata"  [rows]="pageSize()" [first]="data().originalRequest.pageFirstRow" [rowsPerPageOptions]="showRowsPerPage() ? [ 20, 50, 100, {showAll:'Tutti'}] : undefined" >
  <ng-template pTemplate="header" let-columns>
    <tr>
      @if ( allowCheckBoxSelection()) {
        <th style="width: 60px;padding-left:3rem;">
          <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
        </th>
      }
      @for (col of columns; track col.name) {
        @switch(col.type) {
          @case ('PosizioneId') {
            <th [id]="col.type" [ngClass]="{ breadcrumbCell: isHierarchyMode, posizioneCell: !isHierarchyMode }"
                  style="text-align: center;" [ttSortableColumn]="col.name" [style.width]="isHierarchyMode ? '' : col.width"
                  [ttSortableColumnDisabled]="!allowSort() || !allowPosizioneHierarchy() || !col.sortable">
              @if (isHierarchyMode) {
                <i class="fas fa-sitemap"></i>
              }
              @else {
                Posizione&nbsp;
              }
            </th>
          }
          @case ('Arrivo') {
          <th [style.width]="col.width" [id]="col.type">
            Arr/Part
          </th>
          }
          @case ('ActionButtons') {
          <th [style.width]="col.width" [id]="col.type">
          </th>
          }
          @case ('CopiePer') {
          <th [style.width]="col.width" [id]="col.type">
            {{col.title || col.name}}
          </th>
          }
          @default {
          <th [style.width]="col.width" [id]="col.type" [ttSortableColumn]="col.propName" [ttSortableColumnDisabled]="!allowSort() || !col.sortable">
            {{col.title || col.name}}
            @if (allowSort() && col.sortable) {
              <p-treeTableSortIcon [field]="col.propName"></p-treeTableSortIcon>
            }
          </th>
          }
        }
      }
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
    @switch (rowData.type) {
    @case ('F') {
    <tr>
      <td [class]="isHierarchyMode ? 'breadcrumbCell': 'posizioneCell'">
        <span [ngClass]="{ 'breadcrumb red': rowData.deepLevel >= 1, 'half': rowData.deepLevel === 1 }"></span>
        <span [ngClass]="{ 'breadcrumb orange': rowData.deepLevel >= 2, 'half': rowData.deepLevel === 2 }"></span>
        <span [ngClass]="{ 'breadcrumb yellow': rowData.deepLevel >= 3, 'half': rowData.deepLevel === 3 }"></span>
      </td>
      <td [attr.colspan]="folderColSpan" style="text-align: initial;">
        <div class="setFolder">
          <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
          <span class="mLeft10" [pTooltip]="rowData.descrizione" tooltipPosition="top" [showDelay]="200">
            {{rowData.sigla}}
            @if (rowData.descrizione) {
            - {{rowData.descrizione}}
            }
          </span>
          @if (rowData.deepLevel === hierarchyFascicoloLevel) {
          <div class="filterCircles">
            <app-documenti-list-circle color="orangered" filter="Evidenza" [data]="rowData.circles"
              (changed)="circleChanged($event, rowData.posizioneId)">
            </app-documenti-list-circle>
            <app-documenti-list-circle color="#ffab00" filter="Trattazione" [data]="rowData.circles"
              (changed)="circleChanged($event, rowData.posizioneId)">
            </app-documenti-list-circle>
            <app-documenti-list-circle color="#00c853" filter="Firma" [data]="rowData.circles"
              (changed)="circleChanged($event, rowData.posizioneId)">
            </app-documenti-list-circle>
            <app-documenti-list-circle color="#2962ff" filter="Visione" [data]="rowData.circles"
              (changed)="circleChanged($event, rowData.posizioneId)">
            </app-documenti-list-circle>
          </div>
          }
        </div>
      </td>
      <td class="text-right">
        @if (!rowData?.data?.posizioneTree[0]?.chiuso && rowData?.posizioneTree.length <= hierarchy.length) { <button
          *hasClaim="GassClaims.DocModifica" pButton type="button" icon="fas fa-plus" title="Nuovo documento"
          (click)="selectedDocument(rowData)"></button>
          }
      </td>
    </tr>
    }
    @case ('D') {
    <tr [ttSelectableRow]="rowNode" [ttSelectableRowDisabled]="!allowSelection() && !allowCheckBoxSelection()" [class]="getRowCssClass(rowData)">
      @if (allowCheckBoxSelection()) {
        <td class="flex align-self-center">
          <p-treeTableToggler [rowNode]="rowNode" />
          <p-treeTableCheckbox [value]="rowNode" />
        </td>
      }
      @for (col of columns; track col.name) {      
      @switch(col.type) {
      @case ('PosizioneId') {
      @if (isHierarchyMode) {
      <td class="breadcrumbCell">
        <span [ngClass]="{ 'breadcrumb red': rowData.deepLevel >= 1 }"></span>
        <span [ngClass]="{ 'breadcrumb orange': rowData.deepLevel >= 2 }"></span>
        <span [ngClass]="{ 'breadcrumb yellow': rowData.deepLevel >= 3 }"></span>
      </td>
      }
      @else {
      <td class="posizioneCell">
        <app-position-value [posizione]="rowData.posizioneTree"></app-position-value>
      </td>
      }
      }
      @case ('Arrivo') {
      <td>
        <div [ngClass]="rowData.arrivo ? 'docIn' : 'docOut'"
          [title]="rowData.arrivo ? 'Documento in arrivo' : 'Documento in partenza'" class="docIn">
        </div>
      </td>
      }
      @case ('ActionButtons') {
      <td class="action-buttons">
        @if (items[rowData.documentoId] && items[rowData.documentoId].length) {
        <p-splitButton class="download" label="" icon="pi pi-save" declassify
          (onClick)="checkActionAllegato(items[rowData.documentoId][0].state)" appendTo="body"
          [menuStyle]="{'word-break': 'break-word'}"
          [model]="items[rowData.documentoId]"></p-splitButton>
        }

        @if (showDeclassificaButton() && isInCarico(rowData.statoId)) {
        <button *hasClaim="GassClaims.DocModifica" pButton type="button" title="Eleva/Declassifica/Proroga"
          icon="fas fa-fw fa-file-download" (click)="declassify.emit(rowData)"></button>
        }

        @if (showDistruggiButton() && isInCarico(rowData.statoId)) {
        <button *hasClaim="GassClaims.DocDistruzione" pButton type="button" title="Distruggi" icon="fas fa-fw fa-trash"
          class="p-button-danger" (click)="destroy.emit(rowData)"></button>
        }

        @if (showDeleteButton()) {
        <button *hasClaim="GassClaims.DocModifica" pButton type="button" title="Cancella" icon="fas fa-fw fa-trash"
          class="p-button-danger" (click)="delete.emit(rowData)"></button>
        }

        @if(showEvidenzaButtons() && isInEvidenza(rowData.statoId)) {
        <ng-container *hasClaim="GassClaims.DocModifica">
          <button pButton type="button" class="p-button-secondary " icon="pi pi-plus" title="Proroga evidenza"
            (click)="prorogaEvidenzaOverlay.toggle($event, rowData.documentoId, rowData.dataScadenza)"></button>
          <button pButton type="button" icon="pi pi-check" title="Passa in trattazione"
            (click)="actionSetInTrattazione(rowData)"></button>
        </ng-container>
        }

        @if(showActionButtons()) {
        <ng-container *hasClaim="GassClaims.DocModifica">
          @if (isInEvidenza(rowData.statoId)) {
          <button pButton type="button" class="p-button-secondary " icon="pi pi-plus" title="Proroga evidenza"
            (click)="prorogaEvidenzaOverlay.toggle($event, rowData.documentoId, rowData.dataScadenza)"></button>
          <p-splitButton icon="pi pi-check" title="Passa in trattazione" appendTo="body" [model]="actionButtons"
            (onClick)="actionSetInTrattazione(rowData)" (onDropdownClick)="setActionableRow(rowData)"></p-splitButton>
          }
          @else if (isAcquisito(rowData.statoId)) {
          <button pButton type="button" icon="fas fa-archive" title="Riporta in archivio"
            (click)="actionSetInArchivio(rowData)"></button>
          }
          @else if (isInArchivio(rowData.statoId)) {
          <p-splitButton icon="fas fa-exchange-alt" title="Modifica stato" appendTo="body" [model]="actionButtons"
            (onClick)="showModificaStato(rowData)" (onDropdownClick)="setActionableRow(rowData)"></p-splitButton>
          }
          @else if (isInCarico(rowData.statoId)) {
          <p-splitButton icon="fas fa-archive" title="Riporta in archivio" appendTo="body" [model]="actionButtons"
            (onClick)="actionSetInArchivio(rowData)" (onDropdownClick)="setActionableRow(rowData)"></p-splitButton>
          }
        </ng-container>
        }

        @if (!rowData?.data?.posizioneTree[0]?.chiuso && rowData?.posizioneTree.length <= hierarchy.length) { <button
          *hasClaim="GassClaims.DocModifica" pButton type="button" icon="fas fa-plus"
          title="Nuovo documento nel fascicolo" (click)="selectedDocument(rowData)"></button>
          }
      </td>
      }        
      @case ('String') {
      <td class="trunc" [pTooltip]="getRowTooltip(col, rowData)" tooltipPosition="top" [showDelay]="200">
        {{rowData[col.propName]}}
      </td>
      }
      @case ('StringLink') {
      <td class="trunc" [pTooltip]="getRowTooltip(col, rowData)" tooltipPosition="top" [showDelay]="200">
        <a [routerLink]="getRowLink(col, rowData)">{{rowData[col.propName]}}</a>
      </td>
      }
      @case ('StringArray') {
      <td class="string-array-cell">
        <ul>
          @for (dest of rowData[col.propName]; track dest) {
          <li>{{dest}}</li>
          }
        </ul>
      </td>
      }
      @case ('Date') {
      <td>{{rowData[col.propName] | date: 'dd/MM/yyyy'}}</td>
      }
      @case ('CopiePer') {
      <td>
        @if (rowData.copiePer?.length) {
        <p-button title="Copie" [label]="''+ rowData.copiePer?.length" [rounded]="true" severity="info"
          styleClass="vertical-align-middle ml-2 text-xs" (onClick)="showCopy(rowData)" />
        }
      </td>
      }
      }
      }
    </tr>
    }
    }
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="activeColumnMetadata.length">
        Nessun documento trovato
      </td>
    </tr>
  </ng-template>
</p-treeTable>
}

<app-proroga-overlay #prorogaEvidenzaOverlay (proroga)="actionProrogaEvidenza($event)"></app-proroga-overlay>
<app-declassifica-dialog [visible]="showDeclassificaDialog()" [documentId]="actionableRow?.documentoId"
  [qualifica]="actionableRow?.qualificaId" [classifica]="actionableRow?.classificaId" (hide)="showDeclassificaDialog.set(false)" (done)="updateResults()">
</app-declassifica-dialog>
<app-state-archive-dialog [visible]="showStateArchiveDialog()" [documentId]="actionableRow?.documentoId"
  (hide)="showStateArchiveDialog.set(false)" (done)="updateResults()">
</app-state-archive-dialog>
<app-distruzione-dialog [visible]="showDistruzioneDialog()" [documentId]="actionableRow?.documentoId"
  [allegati]="distruzioneAllegato??[]" (hide)="showDistruzioneDialog.set(false)" (done)="updateResults()">
</app-distruzione-dialog>
<app-modifica-stato-dialog [visible]="showModificaStatoDialog()" [documentId]="actionableRow?.documentoId"
  (hide)="showModificaStatoDialog.set(false)" (done)="updateResults()">
</app-modifica-stato-dialog>

<app-visualizza-copiaper-dialog [visible]="showCopyDialog()" [protocollo]="actionableRow?.protocollo"
  [copie]="actionableRow?.copiePer" (hide)="showCopyDialog.set(false)">
</app-visualizza-copiaper-dialog>